/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ agency: NonNullable<unknown> }} Portalframe_Denied_BodyInputs */

const en_portalframe_denied_body = /** @type {(inputs: Portalframe_Denied_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.agency} has not opened this part of your portal. Send them a message and they can turn it on.`)
};

/**
* | output |
* | --- |
* | "{agency} has not opened this part of your portal. Send them a message and they can turn it on." |
*
* @param {Portalframe_Denied_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portalframe_denied_body = /** @type {((inputs: Portalframe_Denied_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_Denied_BodyInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_portalframe_denied_body(inputs)
});